import { useState } from 'react'

import LoginForm from '@hapana/shared/web/components/shared/auth/login-form/login-form.component'
import {
  EMAIL_FIELD_NAME,
  PASSWORD_FIELD_NAME,
} from '@hapana/shared/web/components/shared/auth/login-form/login-form.constants'
import {
  PROTOTYPE_LOGIN,
  setPrototypeAuthed,
} from '@hapana/shared/web/services/prototype-mock/config'
import { styles } from '_pages/login/login.styles'

// Reuses the app's real LoginForm so the gate looks identical to the production login page.
// It validates a single shared credential and flips a localStorage flag — see config.js for
// the (deliberate) security caveat. No router hooks: this renders above the Router.
const PrototypeLoginGate = ({ onSuccess }) => {
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = (data) => {
    setIsLoading(true)
    const email = String(data[EMAIL_FIELD_NAME] || '')
      .trim()
      .toLowerCase()
    const password = String(data[PASSWORD_FIELD_NAME] || '')
    if (email === PROTOTYPE_LOGIN.email && password === PROTOTYPE_LOGIN.password) {
      setPrototypeAuthed()
      onSuccess()
      return
    }
    setError('Incorrect email or password.')
    setIsLoading(false)
  }

  return (
    <LoginForm
      onSubmit={handleSubmit}
      isLoading={isLoading}
      error={error}
      onForgotPassword={() => {}}
      onEmailChange={() => {}}
      defaultValues={{ [EMAIL_FIELD_NAME]: '', [PASSWORD_FIELD_NAME]: '' }}
      title="Sign in"
      description="Enter your credentials to view this prototype."
      styles={styles}
    />
  )
}

export default PrototypeLoginGate
